/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Userlastname2Inputs */

const en_entity_userlastname2 = /** @type {(inputs: Entity_Userlastname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Last Name`)
};

const de_entity_userlastname2 = /** @type {(inputs: Entity_Userlastname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "User Last Name" |
*
* @param {Entity_Userlastname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_userlastname2 = /** @type {((inputs?: Entity_Userlastname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Userlastname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_userlastname2(inputs)
	return de_entity_userlastname2(inputs)
});
export { entity_userlastname2 as "entity_userLastName" }